import React from 'react'
import styles from './mainLayout.css'

const MainLayout = (props) => {
  return (
    <div className={styles.main}>
      {props.children}
    </div>
  )
}

MainLayout.propTypes = {}

export default MainLayout



// WEBPACK FOOTER //
// ./src/base/layout/mainLayout.jsx